import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Divider } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  disabled: boolean;
}

const ConsumableFooter: React.FC<Props> = ({ disabled }) => {
  const history = useHistory();

  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack
          path="/app/operational/inventory/consumables"
          disabled={disabled}
        />

        <Button
          block
          type="primary"
          onClick={() =>
            history.push(`/app/operational/inventory/consumables/create`)
          }
          disabled={!hasPermissions([Authorities.REGISTER_CONSUMABLE_ADD])}
        >
          Novo Insumo
        </Button>
      </SpaceForButton>
    </>
  );
};

export default ConsumableFooter;
